import React, { useMemo } from 'react';
import { useSiteSettings } from '../../SiteSettingsContext';

export default function HomeTrustStrip() {
  const { settings: site } = useSiteSettings();
  const store = site.store_copy || {};

  const items = useMemo(() => {
    const lines = [
      store.trust_badge_1,
      store.trust_badge_2,
      store.trust_badge_3,
      store.trust_badge_4,
    ]
      .map((t) => String(t || '').trim())
      .filter(Boolean);
    return lines;
  }, [store.trust_badge_1, store.trust_badge_2, store.trust_badge_3, store.trust_badge_4]);

  if (store.home_trust_strip_enabled === false) return null;
  if (!items.length && !String(store.trust_stat_line || '').trim()) return null;

  const stat = String(store.trust_stat_line || '').trim();

  return (
    <section className="home-trust-strip" aria-label="Why shop with us">
      <div className="container store-page__container">
        {stat ? <p className="home-trust-strip__stat">{stat}</p> : null}
        {items.length ? (
          <ul className="home-trust-strip__list">
            {items.map((label) => (
              <li key={label} className="home-trust-strip__item">
                <span className="home-trust-strip__check" aria-hidden>
                  ✓
                </span>
                {label}
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </section>
  );
}
